











import { Condition } from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'
import { color } from '@ajax/vue/components/templates/item-list/condition/contactlens/view/assets'
import { Component, Prop, Vue } from 'vue-property-decorator'
import BaseButtonVue from './BaseButtonVue.vue'

@Component({
  components: {
    BaseButtonVue,
  },
})
export default class ColorButtonView extends Vue {
  @Prop({ required: true })
  readonly condition: Condition

  get colorIconPath(): string {
    const colorName = this.condition.value.split('.').reverse()[0]

    return color(`${colorName}.png`)
  }

  onClick(condition: Condition) {
    this.$emit('click', condition)
  }
}
